<template>
    <div class="table-responsive voffset20">
        <table width="100%" cellspacing="0" cellpadding="0" class="table watchlist">								
            <thead>
									<tr>
										<th>Trading Date</th>
										<th>Pick Details</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(day, idx) in dates" :key="idx" >
										<td nowrap="nowrap">
											{{day.date | formatDate2 }}</td>
                                        <td>
                                            <a href="#" class="btn btn-primary" @click="$emit('loadHistory', {date:day.date})">View 
                                            <span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span></a>
                                        </td>
									</tr>
																		
								</tbody>
							</table>
	</div> 
</template>

<script>
import axios from 'axios'

export default {
    name:'PortflioPage',
    components: {
        
    },
    props:{
      portfolio: { type: Object, required: true }
    },
    data(){
        return {
            dates: []
        }
    },
    async mounted(){ 
        let query = '/api/portfolio/'+this.portfolio.id+'/history-dates';
        const e = await axios.get(query);
        this.dates =  e.data.payload ?  e.data.payload.map((x) => {return {idx: x, date: new Date(x)}}) : []
    }
}
</script>